// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"480":"621cd5b1","787":"cd4cc755"}[chunkId] + ".chunk.js";
};